var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 16.8H9.7V9.4h1.5v7.4zm3.1-7.4h-1.5v7.4h1.5V9.4zm5.2-1.3h-1.1L17 19.5H6.9L5.6 8.1H4.5V6.6H9.1V4.5H15v2.1H19.6v1.5zm-8.9-1.5h2.9V6h-2.9v.6zm6.3 1.5H7.1L8.3 18h7.5l1.1-9.9z"
  })));
};
export { SvgTrash as ReactComponent };